/** 订阅上报优先使用有效优惠价，保留 0 元优惠；无优惠时回退商品价格。 */
export function getSubscribeTrackingPrice(product: {
  price: string | number
  preferentialPrice?: string | number | null
}): number {
  const preferentialPrice = product.preferentialPrice
  if (preferentialPrice !== null && preferentialPrice !== undefined && String(preferentialPrice).trim() !== '') {
    const price = Number(preferentialPrice)
    if (Number.isFinite(price) && price >= 0)
      return price
  }

  return Number(product.price)
}
